export interface IResolvedOperationBase {
  id: string;
  [key: string]: unknown;
}

export interface IFuelOperationBasesSource {
  fuelOperationBases?: unknown;
  distributorOperationalBases?: Array<{
    operationBaseId?: string;
    operationBase?: unknown;
  } | null> | null;
}

function isOperationBase(value: unknown): value is IResolvedOperationBase {
  return Boolean(
    value && typeof value === 'object' && typeof (value as { id?: unknown }).id === 'string'
  );
}

export function resolveFuelOperationBases(
  distributor: IFuelOperationBasesSource | null | undefined
): IResolvedOperationBase[] {
  const fuelOperationBases = distributor?.fuelOperationBases;
  if (Array.isArray(fuelOperationBases)) {
    const flat = fuelOperationBases.filter(isOperationBase);
    if (flat.length > 0) {
      return flat;
    }
  }

  const fromPivots = (distributor?.distributorOperationalBases ?? [])
    .map((pivot) => pivot?.operationBase)
    .filter(isOperationBase);

  return fromPivots;
}
